export enum ExtraTripMotive {
	Absenteeism = 'Absenteeism',
	SpecialServices = 'SpecialServices',
	VacancyCovering = 'VacancyCovering',
}

export type ExtraTripMotiveType = ExtraTripMotive | null;

export enum AbsenteeismCategory {
	Justified = 'Justified',
	NotJustified = 'NotJustified',
}

export type AbsenteeismCategoryType = AbsenteeismCategory | null;
